module.exports = __webpack_public_path__ + "static/media/technohunt.440d9814.pdf";